/* Native Shopify search: no catalog download or client-side result filtering. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.searchReady) return;
    root.dataset.searchReady = 'true';
    const form = root.querySelector('[data-search-form]');
    if (!form) return;
    const facets = root.querySelector('[data-search-facets]');
    const backdrop = root.querySelector('.st-catalog-backdrop');
    const desktop = matchMedia('(min-width:750px)');
    let opener;
    let previousOverflow = '';
    const syncDensity = () => {
      const mode = desktop.matches ? 'desktop' : 'mobile';
      const columns = Number(root.dataset[mode + 'Columns']);
      root.querySelectorAll('[data-search-columns]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.searchColumns) === columns)));
      const sizes = desktop.matches ? `(max-width:1199px) ${Math.ceil(88 / columns)}vw, ${Math.ceil(77 / columns)}vw` : `${Math.ceil(100 / columns)}vw`;
      root.querySelectorAll('.st-card-image').forEach(image => image.setAttribute('sizes', sizes));
    };
    for (const mode of ['mobile', 'desktop']) {
      try {
        const stored = Number(sessionStorage.getItem('st-catalog-columns-' + mode));
        if ((mode === 'mobile' ? [2, 3, 4] : [3, 4, 5]).includes(stored)) root.dataset[mode + 'Columns'] = stored;
      } catch {}
    }
    const close = () => {
      if (!root.classList.contains('is-filter-open')) return;
      root.classList.remove('is-filter-open');
      facets.removeAttribute('role'); facets.removeAttribute('aria-modal');
      backdrop.hidden = true;
      document.body.style.overflow = previousOverflow;
      root.querySelector('[aria-controls]')?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    };
    root.addEventListener('click', event => {
      const density = event.target.closest('[data-search-columns]');
      if (density) {
        const mode = desktop.matches ? 'desktop' : 'mobile';
        root.dataset[mode + 'Columns'] = density.dataset.searchColumns;
        try { sessionStorage.setItem('st-catalog-columns-' + mode, density.dataset.searchColumns); } catch {}
        syncDensity();
      }
      const open = event.target.closest('[data-search-open]');
      if (open) {
        opener = open;
        if (!root.classList.contains('is-filter-open')) previousOverflow = document.body.style.overflow;
        root.classList.add('is-filter-open');
        facets.setAttribute('role', 'dialog'); facets.setAttribute('aria-modal', 'true');
        backdrop.hidden = false; document.body.style.overflow = 'hidden';
        root.querySelector('[aria-controls]')?.setAttribute('aria-expanded', 'true');
        const target = open.dataset.searchOpen;
        const group = target === 'all' ? null : facets.querySelector(`[data-search-facet="${target}"]`);
        if (group) { group.open = true; group.scrollIntoView({block:'start'}); }
        (group?.querySelector('input:not(:disabled)') || facets.querySelector('[data-search-close]'))?.focus();
      }
      if (event.target.closest('[data-search-close]')) close();
      const pageSize = event.target.closest('[data-search-page-size]');
      if (pageSize) {
        event.preventDefault();
        const url = new URL(location.href);
        url.searchParams.delete('page');
        if (pageSize.dataset.searchPageSize === '48') url.searchParams.set('view', 'more');
        else url.searchParams.delete('view');
        location.assign(url);
      }
    });
    root.addEventListener('keydown', event => {
      if (!root.classList.contains('is-filter-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusables = Array.from(facets.querySelectorAll('a,button,input,summary')).filter(node => !node.disabled && node.getClientRects().length);
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    root.querySelector('[data-search-sort]')?.addEventListener('change', () => form.requestSubmit());
    desktop.addEventListener('change', () => { close(); syncDensity(); });
    syncDensity();
  }
  document.querySelectorAll('[data-st-catalog-search]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-st-catalog-search]').forEach(init));
})();
